import React, {ReactElement, useCallback} from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Checkbox, Typography} from '@customink/pigment-react';
import TextField from '@mui/material/TextField';
import {useAppSelector, useAppDispatch} from '../../hooks';
import {addPendingDetail} from '../../slices/storesSlice';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import './index.scss';

type PromoMessageProps = {
  storeSlug: string;
};

const PromoMessageForm: React.FC<PromoMessageProps> = ({
  storeSlug
}: PromoMessageProps): ReactElement => {
  const dispatch = useAppDispatch();
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const pendingDetails = useAppSelector(state => state.stores.pendingDetails);
  const bannerEnabled =
    pendingDetails?.bannerEnabled !== undefined
      ? pendingDetails.bannerEnabled
      : storeDetails?.bannerEnabled;
  const bannerText =
    pendingDetails?.bannerText !== undefined
      ? pendingDetails.bannerText
      : storeDetails?.bannerText;

  const onTextChange = useCallback(
    e => {
      dispatch(addPendingDetail({key: 'bannerText', val: e.target.value}));
    },
    [dispatch]
  );
  const onCheckboxChange = useCallback(
    e => {
      dispatch(addPendingDetail({key: 'bannerEnabled', val: e.target.checked}));
    },
    [dispatch]
  );

  return (
    <div className="promoMessageForm">
      <Typography variant="captionLarge" className="promoMessageForm-heading">
        Give store updates, promote sales, or show an alert in the message bar.
      </Typography>
      <FormControlLabel
        control={
          <Checkbox checked={bannerEnabled} onChange={onCheckboxChange} />
        }
        label={
          <Typography className="checkboxText" variant="captionLarge">
            Add an announcement
          </Typography>
        }
        className="bannerEnabledCheckbox"
      />
      {bannerEnabled && (
        <>
          <TextField
            id="outlined-multiline-flexible"
            multiline
            minRows={4}
            value={bannerText}
            onChange={onTextChange}
            placeholder="This is a great space to include an announcement for your store."
            inputProps={{maxLength: 150}}
          />
          <Typography
            variant="captionRegular"
            className="promoMessageForm-subHeading">
            150 character maximum
          </Typography>
        </>
      )}
    </div>
  );
};

export default PromoMessageForm;
